import { Button, Flex, Text } from "@chakra-ui/react";
import { BsCameraVideo, BsMic } from "react-icons/bs";
import { MdGroupAdd } from "react-icons/md";
import useSmallScreen from "../../../../components/useSmallScreen";
import LiveStreamChat from "./LiveStreamChat";
import { useLocalParticipant } from "@livekit/components-react";
import { Track, createLocalTracks } from "livekit-client";
import { useCallback, useEffect, useRef, useState } from "react";
import Chat from "../../../../components/livekit/host-chat";
import { useGetState } from "../../../../context/useGetState";

function LiveStreamBottomLargeScreenControls({ viewingLiveStream,roomName,username }) {
  const { state } = useGetState();
  const user = state?.userInfo?.username;
  const [smallScreen] = useSmallScreen();
  const [videoTrack, setVideoTrack] = useState();
  const [audioTrack, setAudioTrack] = useState();
  const [isPublishing, setIsPublishing] = useState(false);
  const [isUnpublishing, setIsUnpublishing] = useState(false);
  const previewVideoEl = useRef(null);
  let btnStyle = {size: "xs",
  p: "15px 15px",
  fontSize: ".8em",
  borderRadius: "9px",
  bg: "#D9D9D9",
  color: "#000",
};

  const { localParticipant } = useLocalParticipant();

  const createTracks = async () => {
    const tracks = await createLocalTracks({ audio: true, video: true });
    tracks.forEach((track) => {
      switch (track.kind) {
        case Track.Kind.Video: {
          if (previewVideoEl?.current) {
            track.attach(previewVideoEl.current);
          }
          setVideoTrack(track);
          break;
        }
        case Track.Kind.Audio: {
          setAudioTrack(track);
          break;
        }
      }
    });
  };

  useEffect(() => {
    void createTracks();
  }, []);

  useEffect(() => {
    return () => {
      videoTrack?.stop();
      audioTrack?.stop();
    };
  }, [videoTrack, audioTrack]);

  const togglePublishing = useCallback(async () => {
    if (isPublishing && localParticipant) {
      setIsUnpublishing(true);

      if (videoTrack) {
        void localParticipant.unpublishTrack(videoTrack);
      }
      if (audioTrack) {
        void localParticipant.unpublishTrack(audioTrack);
      }

      await createTracks();

      setTimeout(() => {
        setIsUnpublishing(false);
      }, 2000);
    } else if (localParticipant) {
      if (videoTrack) {
        void localParticipant.publishTrack(videoTrack);
      }
      if (audioTrack) {
        void localParticipant.publishTrack(audioTrack);
      }
    }

    setIsPublishing((prev) => !prev);
  }, [audioTrack, isPublishing, localParticipant, videoTrack]);
  // const deleteStream = async () => {
  //   console.log('delete stream function')
  //   if(username && roomName){
  //     const resp = await fetch(`https://livestream-ruby.vercel.app/api/host/delete?room=${roomName}&username=${username}`);
  //     const data = await resp.json();
  //     console.log('delete results',data)
   


  //   }

  // };
 

  return (
    <Flex
      gap={["5px", "40px"]}

      style={{ marginTop: -300 }}
      flexWrap={[!viewingLiveStream ? "wrap" : "nowrap", "nowrap"]}
      flexDir={"row"}
      alignItems={["flex-end", "flex-end"]}
      position={"absolute"}
      // bottom={["40px", "30px"]}
      px={viewingLiveStream ? "20px" : "unset"}
      right={viewingLiveStream ? "unset" : "20px"}
      left="0"
      w={viewingLiveStream ? "100%" : "unset"}
      justifyContent={viewingLiveStream ? "space-between" : "unset"}
    >
      <Flex
        flexDirection={"row"}
        alignItems={"flex-end"}
        w="100%"
        gap={["5px", "20px"]}
      >
          {/* <Chat /> */}
        <LiveStreamChat viewingLiveStream={viewingLiveStream} />
        {/* {viewingLiveStream && (
          <Flex
            flexDirection={"row"}
            alignItems="center"
            bg={!smallScreen ? "#5C5B5B" : "unset"}
            borderRadius={"10px"}
            p={["unset", "1px 10px"]}
            fontWeight={"600"}
            gap={["unset", "10px"]}
            color="#fff"
            cursor={"pointer"}
          >
            <MdGroupAdd fontSize={!smallScreen ? "3em" : "3em"} />
            {!smallScreen && <Text>Join Stream</Text>}
          </Flex>
        )} */}
      </Flex>

      <Flex alignItems={"center"} gap={["5px", "50px"]}>
        {!viewingLiveStream && (
          <BsMic cursor={"pointer"} fontSize={"3em"} color={btnStyle?.bg} />
        )}
        {!viewingLiveStream && (
          <BsCameraVideo
            cursor={"pointer"}
            fontSize={"3em"}
            color={btnStyle?.bg}
          />
        )}

              {isPublishing && !isUnpublishing ? (
            <div className="flex items-center gap-1">
              <span className="relative mr-1 flex h-3 w-3">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex h-3 w-3 rounded-full bg-red-500"></span>
              </span>
              LIVE
            </div>
          ) : (
            "Stream"
          )}  as{" "}{user}

                  {isPublishing ? (
            <Button
         
            backgroundColor={'red.500'}
          
            color={'white'}
        
              onClick={() =>{
                void togglePublishing()
                // const deleteStream = async () => {
                //   console.log('delete stream function')
                //   if(username && roomName){
                //     const resp = await fetch(`https://livestream-ruby.vercel.app/api/host/delete?room=${roomName}&username=${username}`);
                //     const data = await resp.json();
                //     console.log('delete results',data)
                 
            
            
                //   }
            
                // };
                // void deleteStream();
              } }
              disabled={isUnpublishing}
            >
              {isUnpublishing ? "Stopping..." : "Stop stream"}
            </Button>
          ) : (
            <Button
            backgroundColor={'green.500'}
          
            color={'white'}
              onClick={() => void togglePublishing()}
              // className="animate-pulse"
            >
              Start stream
            </Button>
          )}
      </Flex>
    </Flex>
  );
}

export default LiveStreamBottomLargeScreenControls;
